import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';

@Component({
  selector: 'pm-contrasena-list',
  templateUrl: './contrasena-list.component.html',
  styleUrls: ['./contrasena-list.component.sass']
})
export class ContrasenaListComponent {
  public pageTitle = 'CONTRASEÑA';

  public showContrasena = true;
  public showConfirmContrasena = false;
  public showChangeContrasena = false;

  // public showContrasena = false;
  // public showConfirmContrasena = true;
  // public showChangeContrasena = false;



  public editnumber = 0;
}
